/**
 * Bottom navigation bar height constant (M100 / DASH-TD1, Step 6).
 *
 * The rendered nav bar height is `calc(BOTTOM_NAV_HEIGHT_PX + env(safe-area-inset-bottom))`.
 * This constant is the baseline pixel height (the fixed chrome above the safe area).
 *
 * Shared between:
 *  - BottomNav.tsx  (the rendered element height)
 *  - TaskListPage.tsx (FAB dock math + list container bottom padding)
 *
 * Never use an inline `56` anywhere the nav height is referenced — import this constant.
 */
export const BOTTOM_NAV_HEIGHT_PX = 56;
